<template>
  <div class="address">
    <van-nav-bar
      fixed
      title="收货地址"
      left-text="返回"
      right-text="+"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <AddressItem :list="ReceivedAddress" />
  </div>
</template>

<script>
import AddressItem from '@/components/AddressItem.vue'

export default {
  name: 'Address',
  components: {
    AddressItem
  },
  computed: {
    // 收货地址列表
    ReceivedAddress () {
      return this.$store.getters['address/receivedAddress']
    }
  },
  created () {
    this.$store.dispatch('address/getReceivedAddressList')
  },
  methods: {
    // 返回
    onClickLeft () {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace('/user')
      }
    },
    // 新增地址
    onClickRight () {
      this.$router.push('/editaddress')
    }
  }
}
</script>

<style lang="less" scoped>
.address {
  min-height: 100vh;
  background-color: #f7f7f7;
  padding-top: 46px;
  /deep/ .van-nav-bar__arrow { color: #333; }
  /deep/ .van-nav-bar__text { color: #333; }
}
</style>
